import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../_shared/confirm-modal/confirm-modal.component';
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";

@Component({
  selector: 'app-send-report-popup',
  templateUrl: './send-report-popup.component.html',
  styleUrl: './send-report-popup.component.scss'
})

export class SendReportPopupComponent {

  emailTypeForReport = [
    { key: 'Test', emailType: 'test' },
    { key: 'live', emailType: 'live' },
  ];
  emailForm!: FormGroup;
  emails: string[] = [];
  testEmails!: string;
  clubEmails!: string;
  emailFormSubmitted = false;
  selectControl: FormControl = new FormControl();
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  defaultVal = {};
  ngOnInit(): void { }

  constructor(
    public dialogRef: MatDialogRef<SendReportPopupComponent>,
    private formBuilder: FormBuilder,
    public MatDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: {
      testEmails: string;
      clubEmails: string;
    },
  ) {
    this.sendReportForm(this.defaultVal);
    ({testEmails: this.testEmails, clubEmails: this.clubEmails} = data);  //setting values to testEmail and clubEmails from data via object-destructuring 
  }

  //function to change the email based on the emailtype selected
  onEmailTypeChange(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    // set emails in textArea based on the selected emailtype
    if (selectedValue === 'test') {
      this.emailForm.controls['emailsToNotify'].setValue(this.testEmails);
      this.emails = this.splitIfComma(this.testEmails);
    } else if (selectedValue === 'live') {
      this.emailForm.controls['emailsToNotify'].setValue(this.clubEmails);
      this.emails = this.splitIfComma(this.clubEmails);
    } else {
      this.emails = [];
    }
  }

  //function to split the emails from ','
  splitIfComma(value: any) {
    if (!value) return [];
    return value.includes(',') ? value.split(',') : [value];
  }

  //function to confirm is user really want to send email-report
  SendAnalyticsReportByEmail(manageEmailForm: FormGroup) {
    this.emailFormSubmitted = true;

    if (manageEmailForm.invalid) { return; }

    const confirmationMsg = {
      title: 'Sending Analytics Report',
      message: 'Are you sure you want to send the analytics report?',
    };

    const dialogRef = this.MatDialog.open(ConfirmModalComponent, {
      // width: '400px',
      data: confirmationMsg
    });

    dialogRef.afterClosed().subscribe((isConfirmed) => {
      if(isConfirmed){
        this.dialogRef.close(this.emails); // Pass any data, you want to send back to the parent component.
      }
    });
  }

  //functionn to generate send-report email form
  private sendReportForm(values: any) {
    this.emailForm = this.formBuilder.group({
      emailType: new FormControl(
        values.emailType ? values.emailType : '',
        Validators.required
      ),
      emailsToNotify: new FormControl(
        values.emailsToNotify ? values.emailsToNotify : '',
        [Validators.required, Validators.minLength(1)]
      ),
    });
  }

  //function to add email from input field
  addEmail(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.trim();

    if (value && this.validateEmail(value)) {
      this.emails.push(value);
      this.emailForm.get('emailsToNotify')?.setValue(this.emails);
    }

    if (input) {
      input.value = '';
    }
  }

  //function to remove email from input field
  removeEmail(email: string): void {
    const index = this.emails.indexOf(email);
    if (index >= 0) {
      this.emails.splice(index, 1);
      this.emailForm.get('emailsToNotify')?.setValue(this.emails);
    }
  }

  //function ot validate emal-format in input
  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    return emailRegex.test(email);
  }

}
